import React, { Component } from 'react';
//import { Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Media } from 'reactstrap';
//import { Link } from 'react-router-dom';


class Engine extends Component {

  constructor(props) {
        super(props);
    }
render() {
        return (
          <iframe src="https://fritz.chessbase.com" width="760" height="480">
              </iframe>
        );
    }
}

export default Engine;
